import {useCallback, useEffect, useRef, useState} from "react";
import {emptyDeployerForm, mapDeployerToForm} from "../contracts";
import {DialogShell} from "./DialogShell";
import {useTranslation, i18n} from "../../../shared/i18n";


const FIELDS = [
    {name: "name", get label() { return i18n.t("sections.deployers.p52"); }, required: true},
    {name: "username", get label() { return i18n.t("sections.deployers.p10"); }, required: true},
    {name: "phone_number", get label() { return i18n.t("sections.deployers.p9"); }, required: true},
    {name: "email", label: "Email", type: "email", required: true},
];

export const DeployerFormDialog = ({
    open,
    mode,
    deployer,
    pending,
    error,
    onCancel,
    onSubmit,
    hideCommission = false,
    createTitle,
}) => {
    const {t} = useTranslation();
    const editing = mode === "edit";
    const [form, setForm] = useState(emptyDeployerForm);
    const passwordRef = useRef(null);

    useEffect(() => {
        if (!open) {
            setForm(emptyDeployerForm());
            return;
        }
        setForm(editing ? mapDeployerToForm(deployer) : emptyDeployerForm());
    }, [deployer, editing, open]);

    const setValue = (name, value) => setForm((current) => ({...current, [name]: value}));
    const clearSecret = useCallback(() => {
        if (passwordRef.current) passwordRef.current.value = "";
        setForm((current) => ({...current, password: ""}));
    }, []);
    const cancel = () => {
        clearSecret();
        onCancel();
    };
    const submit = (event) => {
        event.preventDefault();
        const payload = {...form};
        if (editing) {
            delete payload.password;
        } else {
            payload.password = payload.password.trim();
        }
        clearSecret();
        onSubmit(payload);
    };

    return (
        <DialogShell
            open={open}
            title={editing ? t("sections.deployers.p53") : (createTitle || t("sections.deployers.p25"))}
            entity={editing ? (deployer?.name || deployer?.username) : t("sections.deployers.p54")}
            pending={pending}
            onClose={cancel}
        >
            <form className="deployer-form" onSubmit={submit}>
                <div className="deployer-form-grid">
                    {FIELDS.map((field) => (
                        <label key={field.name}>
                            <span>{field.label}</span>
                            <input
                                type={field.type || "text"}
                                required={field.required}
                                disabled={pending}
                                value={form[field.name]}
                                onChange={(event) => setValue(field.name, event.target.value)}
                            />
                        </label>
                    ))}
                    {!editing ? (
                        <label>
                            <span>{t("sections.deployers.p55")}</span>
                            <input
                                ref={passwordRef}
                                type="password"
                                autoComplete="new-password"
                                required
                                disabled={pending}
                                value={form.password}
                                onChange={(event) => setValue("password", event.target.value)}
                            />
                        </label>
                    ) : null}
                    {hideCommission ? null : (
                        <label>
                            <span>{t("sections.deployers.p75")}</span>
                            <input
                                type="text"
                                inputMode="decimal"
                                required
                                disabled={pending}
                                value={form.commission_percent}
                                onChange={(event) => setValue("commission_percent", event.target.value)}
                                placeholder={t("sections.deployers.p76")}
                            />
                        </label>
                    )}
                    <label className="deployer-form-wide">
                        <span>{t("sections.deployers.p56")}</span>
                        <textarea disabled={pending} value={form.note} onChange={(event) => setValue("note", event.target.value)} />
                    </label>
                </div>
                {error?.message ? <div className="deployer-dialog-error" role="alert">{error.message}</div> : null}
                <footer className="deployer-dialog-footer">
                    <button type="button" className="admin-button admin-button-secondary" disabled={pending} onClick={cancel}>{t("sections.deployers.p50")}</button>
                    <button type="submit" className="admin-button admin-button-primary" disabled={pending}>
                        {pending ? t("sections.deployers.p57") : editing ? t("sections.deployers.p58") : t("sections.deployers.p59")}
                    </button>
                </footer>
            </form>
        </DialogShell>
    );
};
